import {load} from '@fingerprintjs/botd';
import {isObject} from 'lodash';
import Cookies from 'js-cookie';
import axios from './axiosService';

// @see https://dev.fingerprint.com/docs/quick-start-guide
import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro'

// @see https://dev.fingerprint.com/docs/cloudfront-proxy-integration#step-2---create-path-variables
//const FPJS_BEHAVIOR_PATH = 'k6s3t8rj9n2e'
//const FPJS_AGENT_DOWNLOAD_PATH = 'p4l9m2w1c7o6'
//const FPJS_GET_RESULT_PATH = 'x5y2d3q8a1b9'

function getPublicKey() {
  if (isObject(window.config)) {
    return window.config.fp_public_key;
  } else if (isObject(window.ML)) {
    return window.ML.fp_public_key;
  }
}

export default {
  updateHit(hitUUID, isBot) {
    if (hitUUID && isBot) {
      const form = {
        is_fingerprint_bot: isBot, // MLD-5220
      }
      return axios.patch(`/api/fingerprint/hits/${hitUUID}`, form).catch(() => {
      });
    }
    return Promise.resolve(true);
  },
  async detectBot() {
    return load({monitoring: false})
      .then(botDetector => botDetector.detect())
      .then(result => {
        //console.log('fingerprintService result', result);
        if (result && result.bot) {
          // Log the bot details
          const form = {
            bot: result.bot,
            kind: result.botKind,
          }
          axios.post(`/api/fingerprint/bot/detected`, form).catch(() => {
          })
        }
        return result;
      })
      .catch(err => {
        console.log('fingerprintService error', err);
        return null;
      })
  },
  /**
   * MLD-5093
   * @see https://github.com/fingerprintjs/BotD/blob/main/docs/api.md
   */
  getVisitorID() {
    //return sessionStorage.getItem('fp.visitorID');
    return Cookies.get('fp.visitorID') ?? null;
  },
  setVisitorID(visitorID) {
    try {
      const cookieSettings = {
        expires: 1,
        sameSite: 'strict',
        secure: true,
      }
      Cookies.set('fp.visitorID', visitorID, cookieSettings);
    } catch (e) {
    }
  },
  async getVisitor() {
    // Initialize an agent at application startup.
    const visitorID = this.getVisitorID();
    if (visitorID) {
      //console.log('fingerprintService has visitor ID', visitorID);
      return Promise.resolve(visitorID);
    } else {
      try {
        return FingerprintJS.load({
          apiKey: getPublicKey(),
          endpoint: [
            'https://fp.mobilelocker.com',
            FingerprintJS.defaultEndpoint,
          ],
        })
          .then(fp => fp.get({ // @see https://dev.fingerprint.com/docs/js-agent#get-options
            products: ['identification', 'botd'],
          }))
          .then(async (result) => {
            const visitorID = result.visitorId;
            const requestID = result.requestId;
            //console.log('fingerprintService getVisitor() result', visitorID, requestID);
            const event = await axios.get(`/api/fingerprint/events/${requestID}`)
              .then(response => response.data)
              .catch(() => {
              });
            //console.log(`fingerprintService event ${requestID}`, event);
            /*if (event) {
              axios.put(`/api/fingerprint/visitors/${visitorID}`)
                .then(response => response.data)
                .catch(() => {
                });
            }
            console.log(`fingerprintService visitorID ${visitorID}`);*/
            return visitorID;
          })
          .catch(err => {
            console.log('fingerprintService error', err);
            return null;
          })
      } catch (err) {
        console.log('fingerprintService fatal error', err);
        return null;
      }
    }
  }
}
